import {MaterialModule} from "@modules/material.module";
import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";
import {NgModule} from "@angular/core";

import {
  DashboardsBestStatsComponent
} from "@features/dashboards/common/dashboards-best-stats/dashboards-best-stats.component";
import {
  ComparisonDatePickerComponent
} from "@features/dashboards/common/comparison-date-picker/comparison-date-picker.component";
import {
  DashboardsChartSectionComponent
} from "@features/dashboards/common/dashboards-chart-section/dashboards-chart-section.component";
import {
  DashboardFootfallComponentComponent
} from '@features/dashboards/dashboard-footfall-component/dashboard-footfall-component.component';
import {
  DashboardsLeadsReportComponent
} from "@features/dashboards/dashboards-leads-report/dashboards-leads-report.component";
import {
  DashboardsLeasingReportComponent
} from "@features/dashboards/dashboards-leasing-report/dashboards-leasing-report.component";
import {
  DashboardsPerformanceReportComponent
} from "@features/dashboards/dashboards-performance-report/dashboards-performance-report.component";
import {
  DashboardsRetailerReportComponent
} from "@features/dashboards/dashboards-retailer-report/dashboards-retailer-report.component";
import {CustomDateFilterComponent} from '@ui-kit/webkit/components/custom-date-filter/custom-date-filter.component';


const components = [
  ComparisonDatePickerComponent,
  DashboardsBestStatsComponent,
  DashboardsChartSectionComponent,
  DashboardFootfallComponentComponent,
  DashboardsLeadsReportComponent,
  DashboardsLeasingReportComponent,
  DashboardsPerformanceReportComponent,
  DashboardsRetailerReportComponent,
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    CustomDateFilterComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureDashboardsModule {
}
